import { createFileRoute } from '@tanstack/react-router'
import { BackofficePage } from '@/pages/BackofficePage'

export const Route = createFileRoute('/backoffice/')({
  component: BackofficePage,
})
